import styled from 'styled-components'
import Colors from '../../../../themes/Colors'

const UploadAdModalHolder = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 21px;

  .ant-upload.ant-upload-drag {
    border-radius: 8px;
  }

  .dragger-content {
    padding: 16px 0;

    .upload-hint {
      font-size: 12px;
      color: ${Colors.textMuted};
      margin-top: 4px;
    }
  }

  /* Selected-files list (multi-file selection): visible + removable. */
  .selected-files {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .selected-files-head {
      font-size: 13px;
      font-weight: 500;
      color: ${Colors.coal};
    }

    .selected-files-list {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      flex-direction: column;
      gap: 6px;
      max-height: 220px;
      overflow-y: auto;
    }

    .selected-file {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 6px 10px;
      border: 1px solid ${Colors.border};
      border-radius: 6px;

      .file-icon {
        color: ${Colors.primaryAccent};
        flex-shrink: 0;
      }

      .file-name {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: ${Colors.textStrong};
      }

      .file-size {
        flex-shrink: 0;
        font-size: 12px;
        color: ${Colors.textMuted};
      }

      .file-remove {
        flex-shrink: 0;
        cursor: pointer;
        color: ${Colors.textMuted};

        &:hover {
          color: ${Colors.red};
        }
      }
    }
  }

  .upload-breadcrumb {
    font-size: 13px;
    padding: 8px 12px;
    background: ${Colors.background};
    border-radius: 6px;

    /* Collapsed-middle marker: informational, reveals hidden folders on hover. */
    .upload-bc-ellipsis {
      letter-spacing: 1px;
    }
  }
`

export default UploadAdModalHolder
